import PropTypes from 'prop-types';
import {useDispatch} from "react-redux";
import React, { useState } from 'react';

const MnToggleButton = ({activeLabel = 'ON', inactiveLabel = 'OFF', value, onToggle, readOnly}) => {
  const [isToggled, setIsToggled] = useState(value);

  const toggleButton = () => {
    if (!readOnly) {
      setIsToggled(!isToggled);
      if (onToggle) {
        onToggle(!isToggled);
      }
    }
  };

  return (
      <div className={`rounded-pill-button`} onClick={toggleButton}>
        <div className={`rounded-pill-button-bg ${isToggled ? "active" : ""}`} />
        <div className={"rounded-pill-button-switch-container"}>
          <div className={`rounded-pill-button-switch-el ${isToggled ? "active" : ""}`}/>
        </div>
      </div>
  )
}

const ToggleButtonCP = (props) => {
  const dispatch = useDispatch();

  const onToggle = async(value) => {
    const isChecked = value ? 0 : 1;
    await dispatch(props.dataItem.setField(props.rowIndex, props.fieldInfo.Name, isChecked));
    if (props.onEndEditField)
      props.onEndEditField();
  };

  return (
    <MnToggleButton value={!!props.value}
                    readOnly={!!props.readOnly}
                    onToggle={onToggle}
    />
  );
}

ToggleButtonCP.propTypes = {
  dataItem: PropTypes.object,
  fieldInfo: PropTypes.object,
  rowIndex: PropTypes.number,
  readOnly: PropTypes.bool,
  value: PropTypes.any,
  onEndEditField: PropTypes.func
};

export const WebCustomTemplate_ToggleButton = ToggleButtonCP;

export default MnToggleButton;